import { Icon } from 'semantic-ui-react';
import ConfirmModal from '../common/ConfirmModal';

/**
 * Confirmation modal for deleting a person image
 */
const DeleteConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    imageToDelete,
    isDeleting,
    deleteError
}) => {
    return (
        <ConfirmModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={!deleteError ? onConfirm : undefined}
            title="Delete Person Image"
            titleIconName="trash"
            titleIconColor="red"
            confirmText="Delete"
            cancelText={deleteError ? 'Close' : 'Cancel'}
            variant="danger"
            isLoading={isDeleting}
            loadingText="Deleting..."
            confirmDisabled={isDeleting}
            closeOnOverlay={!isDeleting}
        >
            {deleteError ? (
                <div className="confirm-modal-error">
                    <Icon name="warning circle" style={{ margin: 0 }} /> {deleteError}
                </div>
            ) : (
                <p>Are you sure you want to delete this person image?</p>
            )}
            {imageToDelete && (
                <div style={{ textAlign: 'center', marginTop: 12 }}>
                    <img
                        src={imageToDelete.removedBgImage?.url || imageToDelete.thumbnail?.url || imageToDelete.image?.url}
                        alt="Preview"
                        style={{
                            maxWidth: 150,
                            maxHeight: 200,
                            borderRadius: 10,
                            border: '2px solid #e5e7eb',
                            objectFit: 'contain'
                        }}
                    />
                </div>
            )}
        </ConfirmModal>
    );
};

export default DeleteConfirmModal;
